export const env: {
  upcApiBase: string;
} = {
  upcApiBase: process.env.VUE_APP_BASE_URL || ''
};
